/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Dropdown, Image, TableColumnsType, Tag } from "antd";
import EmptyCard from "../../../../../atoms/EmptyCard";
import TableUi from "../../../../../atoms/Table";
import woTable from "../../../../WorkOrders/DummyData/woTable.json";
import { CrossIcon, DeleteIcon } from "../../../../../atoms/CustomIcons";
import { PopUp } from "../../../../../atoms/PopUp";
import ConfirmDelete from "../../../../../atoms/ConfirmDelete";
import { MoreOutlined } from "@ant-design/icons";
import { useRef, useState } from "react";
import ConfirmIcon from "../../../../../atoms/CustomIcons/ConfirmIcon";
import CancelIcon from "../../../../../atoms/CustomIcons/CancelIcon";
import { useNavigate } from "react-router-dom";
import { getInitials } from "../../../../../config/utils";
import Filters from "./Components/Filters";

export default function WorkOrders(props:any) {
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const navigate = useNavigate();
  const companyId = pathSegments[pathSegments.length - 1];
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [archivePopUp, setArchivePopUp] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [archived, isArchived] = useState(false);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const items = [
    {
      key: "1",
      label: (
        <Button type="text" icon={<ConfirmIcon />}>
          Change status to...
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button type="text" icon={<CancelIcon />}>
          Cancel work order
        </Button>
      ),
    },
  ];

  const statusClassMap: Record<string, string> = {
    "in progress": "approval_pending_tag",
    open: "grey_tag",
    completed: "accepted_tag",
    scheduled: "sent_tag",
    closed: "accepted_tag",
  };

  const serviceLineClassMap: Record<string, string> = {
    "landscape maintenance": "green_tag",
    "lawn care": "orange_tag",
    irrigation: "violet_tag",
    construction: "yellow_tag",
  };

  const columns: TableColumnsType = [
    {
      title: "Work order",
      dataIndex: "work_order",
      width: 220,
      render: (text) => text ?? "-",
      fixed: "left",
      sorter: (a, b) => a?.work_order?.localeCompare(b?.work_order),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 170,
      render: (text) => {
        const cls = statusClassMap[text?.toLowerCase()] || "default_tag";
        return (
          <Tag
            className={cls}
            style={{ textTransform: "capitalize", border: 0 }}
          >
            {text}
          </Tag>
        );
      },
      sorter: (a, b) => a?.status?.localeCompare(b?.status),
    },
    {
      title: "Visits",
      dataIndex: "visit",
      width: 140,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.visit - b?.visit,
    },
    // {
    //   title: "Property",
    //   dataIndex: "property",
    //   width: 270,
    //   render: (text) => (text ? text : "-"),
    //   sorter: (a, b) => a?.property?.localeCompare(b?.property),
    // },
    {
      title: "Contract",
      dataIndex: "contract",
      width: 270,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.contract?.localeCompare(b?.contract),
    },
    {
      title: "Service line",
      dataIndex: "service_line",
      width: 270,
      render: (text) => {
        const cls = serviceLineClassMap[text?.toLowerCase()] || "default_tag";
        return text ? <Tag className={cls}>{text}</Tag> : "-";
      },
      sorter: (a, b) => a?.service_line?.localeCompare(b?.service_line),
    },

    {
      title: "Performed by",
      dataIndex: "performed_by",
      width: 140,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.performed_by?.localeCompare(b?.performed_by),
    },

    {
      title: "Crew/Subcontractor",
      dataIndex: "crew",
      width: 180,
      render: (text) => (text ? <Tag>{text}</Tag> : "-"),
      sorter: (a, b) => a?.crew?.localeCompare(b?.crew),
    },

    // {
    //   title: "Production manager",
    //   dataIndex: "production_manager",
    //   width: 180,
    //   render: (text) =>
    //     text?.name ? (
    //       <div style={{ display: "flex", alignItems: "center" }}>
    //         {text?.image_url ? (
    //           <Avatar
    //             size={24}
    //             style={{ marginRight: 8 }}
    //             src={text?.image_url}
    //           />
    //         ) : (
    //           <Avatar size={24} style={{ marginRight: 8 }}>
    //             {getInitials(text?.name, "")}
    //           </Avatar>
    //         )}
    //         <span style={{ textTransform: "capitalize" }}>{text?.name}</span>
    //       </div>
    //     ) : (
    //       "-"
    //     ),
    //   sorter: (a, b) =>
    //     a?.production_manager?.localeCompare(b?.production_manager),
    // },

    {
      title: "Estimated hrs",
      dataIndex: "estimated_hours",
      width: 150,
      render: (text) => (text ? text : "-"),
      align: "right",
      sorter: (a, b) => a?.estimated_hours - b?.estimated_hours,
      className: "right-aligned-sorter",
    },
    {
      title: "Scheduled hrs",
      dataIndex: "scheduled_hours",
      width: 150,
      render: (text) => (text ? text : "-"),
      align: "right",
      sorter: (a, b) => a?.scheduled_hours - b?.scheduled_hours,
      className: "right-aligned-sorter",
    },

    {
      title: "Actual hrs",
      dataIndex: "actual_hours",
      width: 150,
      render: (text) => (text ? text : "-"),
      align: "right",
      sorter: (a, b) => a?.actual_hours - b?.actual_hours,
    },
    {
      title: "Scheduled dates",
      dataIndex: "scheduled_dates",
      width: 250,
      render: (text) => text ?? "-",
      sorter: (a, b) => a?.scheduled_dates - b?.scheduled_dates,
    },

    {
      title: "Progress",
      dataIndex: "progress",
      width: 100,
      render: (text) => text ?? "-",
      align: "right",
      sorter: (a, b) => a?.progress - b?.progress,
      className: "right-aligned-sorter",
    },

    {
      title: "Efficiency",
      dataIndex: "efficiency",
      width: 110,
      render: (text) => (text ? <Tag className="green_tag">{text}</Tag> : "-"),
      align: "right",
      sorter: (a, b) => a?.efficiency - b?.efficiency,
      className: "right-aligned-sorter",
    },

    {
      title: "Estimated labor cost",
      dataIndex: "estimated_cost",
      width: 180,
      render: (text) => text ?? "-",
      align: "right",
      sorter: (a, b) => a?.estimated_cost - b?.estimated_cost,
      className: "right-aligned-sorter",
    },
    {
      title: "Actual labor cost",
      dataIndex: "actual_cost",
      width: 180,
      render: (text) => text ?? "-",
      align: "right",
      sorter: (a, b) => a?.actual_cost - b?.actual_cost,
      className: "right-aligned-sorter",
    },
    {
      title: "Estimated material cost",
      dataIndex: "estimated_material_cost",
      width: 220,
      render: (text) => text ?? "-",
      align: "right",
      sorter: (a, b) => a?.estimated_material_cost - b?.estimated_material_cost,
      className: "right-aligned-sorter",
    },
    {
      title: "Actual material cost",
      dataIndex: "actual_material_cost",
      width: 195,
      render: (text) => text ?? "-",
      align: "right",
      sorter: (a, b) => a?.actual_material_cost - b?.actual_material_cost,
      className: "right-aligned-sorter",
    },
    {
      title: "Projected revenue",
      dataIndex: "projected_revenue",
      width: 180,
      render: (text) => text ?? "-",
      align: "right",
      sorter: (a, b) => a?.projected_revenue - b?.projected_revenue,
      className: "right-aligned-sorter",
    },
    {
      title: "Earned revenue",
      dataIndex: "earned_revenue",
      width: 180,
      render: (text) => text ?? "-",
      align: "right",
      sorter: (a, b) => a?.earned_revenue - b?.earned_revenue,
      className: "right-aligned-sorter",
    },
    {
      title: "Date completed",
      dataIndex: "date_completed",
      width: 170,
      render: (text) => text ?? "-",
      align: "right",
    },

    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              console.log("text", record);
              // setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  console.log("getInitials", getInitials);

  const deleteFunction = () => {
    setLoading(true);
  };

  const deleteClientPopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          selectedRowKeys?.length > 0 ? (
            <>
              Are you sure you want to delete work orders?
              <br />
              This action cannot be undone.
            </>
          ) : (
            <>
              Are you sure you want to delete <b>tableRecord?.name</b>?<br />
              <br />
              This action cannot be undone.
            </>
          )
        }
        btnText={
          selectedRowKeys?.length > 0
            ? `Delete ${
                selectedRowKeys?.length === 1
                  ? selectedRowKeys?.length + " work order"
                  : selectedRowKeys?.length + " work orders"
              }`
            : "Delete order"
        }
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const archiveFunction = () => {
    setLoading(true);
  };

  const confirmArchivedPopUp = {
    visibility: archivePopUp,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => setArchivePopUp(false)}
        heading='{tableRecord?.status === "active" ? "Archive" : "Activate"}'
        paragraph={
          <>
            Are you sure you want to{" "}
            {/* {tableRecord?.status === "active" ? "archive" : "activate"}{" "}
            <b>{tableRecord?.name}</b>? <br /> <br />
            {tableRecord?.status === "active" && (
              <>This crew won’t be available for use.</>
            )} */}
          </>
        }
        btnText={`${
          "Activate"
          // tableRecord?.status === "active" ? "Archive" : "Activate"
        } crew`}
        btnApi={archiveFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setArchivePopUp(false),
  };

  const onClickRow = () => {
    return {
      onClick: () => {
        navigate(`/wo-report/${companyId}`);
      },
    };
  };
  return (
    <div className="profileTableWrapper">
      <Card className="profileTableCard">
        <TableUi
          columns={columns}
          data={{
            count: props.data?.length,
            data: props.data || [],
          }}
          filters={
            <Filters
              setFilters={setFilters}
              filters={filters}
              archived={archived}
              isArchived={isArchived}
              companyId={companyId}
            />
          }
          pageSize={limit}
          setPageSize={setLimit}
          setCurrentPage={setPagination}
          currentPage={pagination}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          onClickRow={onClickRow}
        />
        {woTable?.length === 0 && (
          <div className="empty_wrap">
            <EmptyCard
              imageHeight={220}
              title={
                archived
                  ? "There are no archived work orders"
                  : filters?.search_text
                  ? "No results match the filter or search criteria"
                  : `There are no ${filters?.status ?? "active"} work orders`
              }
              description={
                archived
                  ? "We believe in our absolute success and hope to never have an archived work orders here."
                  : filters?.search_text
                  ? "Try adjusting the filters and search."
                  : ""
              }
              image={
                archived
                  ? "/images/empty-icons/no-archived.svg"
                  : "/images/empty-icons/no-active.svg"
              }
            />
          </div>
        )}
        {selectedRowKeys?.length !== 0 ? (
          <div className="selection_bar">
            <div className="selected_count">
              <Button
                icon={<CrossIcon style={{ color: "white" }} />}
                className="only_icon"
                type="text"
                onClick={() => setSelectedRowKeys([])}
              />
              {selectedRowKeys.length}{" "}
              {`${selectedRowKeys.length === 1 ? "work order" : "work orders"}`}{" "}
              selected
            </div>
            <div className="selection_buttons">
              <Button
                type="text"
                icon={<DeleteIcon />}
                onClick={() => {
                  setIsDeleteModalOpen(true);
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        ) : null}
        <PopUp {...deleteClientPopUp} />
        <PopUp {...confirmArchivedPopUp} />
      </Card>
    </div>
  );
}
